import React, { Component } from 'react';
import 'react-bootstrap';

import store from '../../store/configureStore';
import Pagination from '../../components/pagination/Pagination';
import ActivityBlock from './ActivityBlock';
import { lang } from '../../config/lang';
import { connect } from "react-redux";
import { addNotification } from "../../actions/notificationAction";
import { changeTopBannerAction } from '../../actions/topBannerAction';
import { changeActiveItemAction } from '../../actions/navAction';
import { Businesses, PagesForCaption, CaptionCodes } from '../../config/Helper';
import captionApi from '../../api/captionApi';
import activityApi from '../../api/activityApi';
import ScrollToTop from '../home/ScrollToTop/ScrollToTop'
import { setSideActivityAction } from '../../actions/activityAction';

/****************************************
    Component for activity page
    @author  UYM
    @date    2020.05.13
    @version 0.1    
 ******************************************/
class ActivityList extends Component {

    constructor(props) {
        super(props);
        const search = this.props.history.location.search.split('?');
        let queryParams;
        if (search.length > 1) {
            const query = search[1].split('=');
            if (query.length) {
                queryParams = { [query[0]]: parseInt(query[1]) };
            }

        }
        this.state = {
            curPage: queryParams && queryParams.page ? queryParams.page : 1,
            pages: 0,
            deltaPage: 6,
            arrActivity: [],
            title: '',
            total: 0,
            description: ''
        }

        this.load = this.load.bind(this);
    }

    componentWillMount() {
        this.load();
        store.dispatch(changeActiveItemAction(Businesses.indexOf('activity')));
        store.dispatch(changeTopBannerAction({
            page: 'activity',
            showSearch: false,
            isHome: false
        }));
    }

    componentDidMount() {
        const search = this.props.history.location.search.split('?');
        let queryParams;

        if (search.length > 1) {
            const query = search[1].split('=');

            if (query.length) {
                queryParams = { [query[0]]: parseInt(query[1]) };
                this.setState({ curPage: queryParams.page });

            }
        }
        window.scrollTop('#root');
        window.onClose();
        window.onSetClass('light');
    }

    componentWillUnmount() {

    }

    componentWillUpdate() {

    }

    componentDidUpdate() {
        window.onClose();
    }

    componentWillReceiveProps(newProps) {
        const search = this.props.history.location.search.split('?');
        let queryParams;
        if (search.length > 1) {
            const query = search[1].split('=');
            if (query.length) {
                queryParams = { [query[0]]: parseInt(query[1]) };
                this.setState({ curPage: queryParams.page });
            }

        }
        this.load();
    }

    load() {
        var caption = '';

        captionApi.getCaptions('activity').then((json) => {
            if (json.status === 200) {
                caption = json.data[CaptionCodes[PagesForCaption.indexOf('activity')].indexOf('activity_activities')];
            } else {
                store.dispatch(addNotification(`${lang('server_err')}`, 'error'));
            }
        })

        activityApi.getPaginatedActivities(this.state.curPage).then((json) => {
            if (json.status === 200) {
                this.setState({
                    arrActivity: json.data.data,
                    curPage: json.data.currentPage,
                    pages: json.data.lastPage,
                    total: json.data.total,
                    title: (caption === undefined || caption.title === undefined || caption.title === null) ? "" : caption.title,
                    description: (caption === undefined || caption.description === undefined || caption.description === null) ? "" : caption.description
                });
                // store.dispatch(setSideActivityAction(json.data.data))
            } else {
                store.dispatch(addNotification(`${lang('server_err')}`, 'error'));
            }
        })
    }

    onChangePage(page) {
        // eslint-disable-next-line
        this.state.curPage = page;
        this.props.history.push("/activity" + "?" + "page=" + page);
        this.load();
        window.scrollTop('#activity_section', 100);
    }

    render() {
        return (
            <div>
                <section className="ftco-section1" id="activity_section">
                    <div className="container">
                        <div className="row justify-content-center mt-5 mb-5">
                            {/* <div className="col-md-12 heading-section text-center ftco-animate fadeInUp ftco-animated">
                                <h2 className="mb-4">{this.state.title}</h2>
                                <p>{this.state.description}</p>
                            </div> */}

                            <br />
                            <div>
                                {`${lang('total')}` + this.state.total}
                            </div>
                        </div>
                    </div>
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-12 pr-lg-12">
                                <div className="row">
                                    <div className="col-md-12">
                                        {
                                            this.state.arrActivity.map((activity, key) => (
                                                <div key={key} className="col-md-2 ftco-animate fadeInUp ftco-animated">
                                                    <ActivityBlock
                                                        key={key}
                                                        business={activity.business}
                                                        id={activity.id}
                                                        title={activity.title}
                                                        image={activity.media_filename}
                                                        mediaType={activity.media_filetype}
                                                    />
                                                </div>
                                            ))
                                        }
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>

                <div className="container">
                    <div className="row justify-content-center pb-5">
                        <div className="col-md-12 block-27 text-center">
                            {
                                <Pagination
                                    total={this.state.pages}
                                    curPage={this.state.curPage}
                                    visible={this.state.deltaPage}
                                    onChangePage={(page) => this.onChangePage(page)}
                                />
                            }
                        </div>
                    </div>
                </div>
                <ScrollToTop />
            </div>
        );
    }
}

function mapStateToProps(state) {
    return {
        language: state.language
    };
}

export default connect(mapStateToProps)(ActivityList);